export default __webpack_public_path__ + "static/media/img22.0dd631ef.jpg";